import React from 'react'
import { Link } from 'react-router-dom'
import { Zoom } from 'react-awesome-reveal'
import { Container, Icon } from 'semantic-ui-react'
import bannerPic1 from '../Pictures/banner1.jpg'
import membershipForm from '../Data/Registration Form.DOCX'

export default function JoinPage() {
  const bannerStyle = {
    backgroundImage: `url(${bannerPic1})`,
  }

  const benefits = [
    {
      icon: 'heart',
      title: 'Welfare Solidarity',
      desc: 'Proactive support during critical life moments: marriage, childbirth, bereavement, or hospitalization.',
    },
    {
      icon: 'certificate',
      title: 'Passport Endorsements',
      desc: 'Official witnessing and endorsement of Ghana passport application forms as required by authorities.',
    },
    {
      icon: 'building',
      title: 'Embassy Liaison',
      desc: 'An organized, recognized channel of communication connecting community members to the Ghana Embassy.',
    },
    {
      icon: 'graduation cap',
      title: 'Integration & Seminars',
      desc: 'Regular seminars covering Czech residency, employment, legal updates, healthcare, and higher education.',
    },
    {
      icon: 'users',
      title: 'Cultural Events & Sports',
      desc: 'Annual grill parties, sports tournaments, Independence Day galas, and regional excursions.',
    },
    {
      icon: 'shield',
      title: 'Community Support',
      desc: 'Community advisory and mutual aid for newcomers, students, and families settling in the Czech Republic.',
    },
  ]

  return (
    <div id='joinPage'>
      {/* Hero Banner */}
      <section className='pageHero' style={bannerStyle}>
        <div className='pageHeroOverlay'></div>
        <div className='pageHeroContent'>
          <Zoom triggerOnce>
            <span className='pageHeroBadge'>Membership & Community</span>
            <h1 className='pageHeroHeading'>Join Ghana Union</h1>
            <div className='goldAccentLine' style={{ margin: '14px auto 20px auto' }}></div>
            <p className='pageHeroSubheading'>
              Become part of a recognized, supportive diaspora network. Connect with fellow Ghanaians, access official support, and build lasting friendships across the Czech Republic.
            </p>
            <div style={{ marginTop: '24px', display: 'flex', gap: '14px', justifyContent: 'center', flexWrap: 'wrap' }}>
              <Link to='/form' className='bannerPrimaryBtn'>
                <Icon name='edit' /> Online Registration
              </Link>
              <a href='#dues' className='bannerSecondaryBtn'>
                View Membership Dues
              </a>
            </div>
          </Zoom>
        </div>
      </section>

      {/* Member Benefits Section (Non-Card) */}
      <section className='homeSection'>
        <Container>
          <div className='sectionHeaderCentered'>
            <span className='sectionBadge'>Why Join Us?</span>
            <h2 className='homeSectionTitle'>Membership Benefits</h2>
            <div className='goldAccentLine' style={{ margin: '10px auto 20px auto' }}></div>
            <p className='sectionHeaderDesc'>
              Our union is built on unity, collective welfare, and mutual empowerment for every member.
            </p>
          </div>

          <div className='joinBenefitsGrid'>
            {benefits.map((b, idx) => (
              <article className='joinBenefitItem' key={idx}>
                <div className='joinBenefitIconBox'>
                  <Icon name={b.icon} />
                </div>
                <h3 className='joinBenefitTitle'>{b.title}</h3>
                <p className='joinBenefitDesc'>{b.desc}</p>
              </article>
            ))}
          </div>
        </Container>
      </section>

      {/* Membership Dues Section */}
      <section id='dues' className='homeSection' style={{ backgroundColor: '#fafbfc', borderTop: '1px solid #eef2f6', borderBottom: '1px solid #eef2f6' }}>
        <Container>
          <div className='sectionHeaderCentered'>
            <span className='sectionBadge'>Transparency & Commitment</span>
            <h2 className='homeSectionTitle'>Membership Dues</h2>
            <div className='goldAccentLine' style={{ margin: '10px auto 20px auto' }}></div>
            <p className='sectionHeaderDesc'>
              Dues directly fund our community welfare allocations, emergency assistance, event planning, and administrative operations.
            </p>
          </div>

          <div className='joinDuesGrid'>
            <div className='joinDuesCard'>
              <span className='joinDuesBadge'>One-Time</span>
              <h3 className='joinDuesTitle'>Registration Fee</h3>
              <div className='joinDuesAmount'>
                <span className='duesCurrency'>CZK</span>
                <span className='duesPrice'>200</span>
              </div>
              <p className='joinDuesText'>
                A single onboarding fee upon submitting your registration, covering membership processing and documentation.
              </p>
            </div>

            <div className='joinDuesCard highlight'>
              <span className='joinDuesBadge goldBadge'>Monthly Commitment</span>
              <h3 className='joinDuesTitle'>Monthly Dues</h3>
              <div className='joinDuesAmount'>
                <span className='duesCurrency'>CZK</span>
                <span className='duesPrice'>200</span>
              </div>
              <p className='joinDuesText'>
                Monthly contribution sustaining the welfare fund, bereavement aid, maternity support, and union community activities.
              </p>
            </div>
          </div>
        </Container>
      </section>

      {/* Registration CTAs & Steps Section */}
      <section className='homeSection'>
        <Container>
          <div className='joinCtaBox'>
            <span className='sectionBadge'>Ready to Register?</span>
            <h2 className='homeSectionTitle' style={{ marginBottom: '16px' }}>
              Complete Your Registration Today
            </h2>
            <p style={{ maxWidth: '640px', margin: '0 auto 32px auto', color: '#475569', fontSize: '16px', lineHeight: '1.7' }}>
              Choose between our instant online registration form or download the offline document to submit manually to the secretariat.
            </p>

            <div className='joinActionButtons'>
              <Link to='/form' className='bannerPrimaryBtn'>
                <Icon name='wpforms' /> Start Online Registration
              </Link>
              <a href={membershipForm} download className='eventSecondaryBtn'>
                <Icon name='download' /> Download Form (.DOCX)
              </a>
            </div>
          </div>
        </Container>
      </section>
    </div>
  )
}
